import Vue from 'vue'
import HoverIntent from 'vue2-hover-intent'
Vue.directive('hover-intent', HoverIntent)
